'use client';

import { getFrameUrl } from "app/animate/[[...id]]/animate-utils-client-safe";
import _ from "lodash";
import ModalImage from "react-modal-image";

type FramesProps = {
    jobId : string|undefined,
    frameCount: number|undefined,
    framePattern: string|undefined,
    thumbnailPattern: string|undefined,
}

export default function Frames({ jobId, frameCount, thumbnailPattern, framePattern,  }: FramesProps) {

    if (!jobId || !thumbnailPattern || !framePattern || !frameCount) {
        return <></>
    }

    return <div className='max-w-2xl xl:max-w-4xl mx-auto'>
        <h2 className="mt-3 text-xl lg:text-2xl mb-4">Frames: {frameCount}</h2>
        <div className="div-scrollbar overflow-x-scroll" >
            <div className='flex row justify-between gap-1'>
                {
                    _.range(0, frameCount) .map((frame) => {

                        const thumbUrl = getFrameUrl(jobId, frame, thumbnailPattern);
                        const frameUrl = getFrameUrl(jobId, frame, framePattern);
                    
                        return (thumbUrl && frameUrl)
                            ? <div key={frame} className='flex flex-col items-center'>
                                <ModalImage
                                    key={"img-"+frame}
                                    hideZoom
                                    className='min-w-[128px] max-h-[512px]'
                                    small={thumbUrl}
                                    large={frameUrl}
                                    alt={"frame: " + frame} />
                                <div key={"frn-"+frame} className="text-size-xs px-4">{frame}</div>
                            </div>
                            : <></>;
                    })
                }
            </div>
        </div>
    </div>
}